import { Helmet } from "react-helmet-async";
import { AppConfig } from "../config/config";

export default function SEO({
  title = "Clinic",
  description = "Clinic",
  image = "/metaimage.png",
  url = "https://business.dome-care.com",
  schema
}:any) {
  const fullTitle = `DomeCare | ${title}`;
   const defaultImage = url + "metaimage.png"

  const propImage = `${AppConfig.SERVER_URL}/${image}`.replace(/([^:]\/)\/+/g, "$1");
  const ogImage = image ? propImage : defaultImage

  const schemaObject = schema ?? {
    "@context": "https://schema.org",
    "@type": "Medical",
    name: title,
    description: description,
    image: ogImage,
    url: url,
  };

  return (
    <Helmet>
      <title>{fullTitle}</title>

      <meta name="description" content={description} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:url" content={url} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {/* Mobile */}
      <meta name="viewport" content="width=device-width, initial-scale=1" />

      {/* Theme */}
      <meta name="theme-color" content="#ffffff" />

      <script type="application/ld+json">
        {JSON.stringify(schemaObject)}
      </script>
    </Helmet>
  );
}